import { render, staticRenderFns } from "./AdminOrdersSearch.vue?vue&type=template&id=3ba77c6a&"
import script from "./AdminOrdersSearch.vue?vue&type=script&lang=js&"
export * from "./AdminOrdersSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports